import type { EmblaCarouselType } from 'embla-carousel';

const widthsByCarousel = new WeakMap<EmblaCarouselType, WeakMap<Element, number>>();

/** Modra product tracks use horizontal writing-mode and horizontal slides.
 * Height-only image/text updates cannot change their scroll snaps. Use sizes
 * already calculated by the browser instead of forcing another layout read.
 * Unknown data always delegates to Embla, including older browser fallbacks.
 */
export function watchHorizontalProductResize(api: EmblaCarouselType, entries: ResizeObserverEntry[]) {
  let widths = widthsByCarousel.get(api);
  if (!widths) {
    widths = new WeakMap<Element, number>();
    widthsByCarousel.set(api, widths);
  }
  let needsDefaultMeasurement = false;
  for (const entry of entries) {
    const boxes = entry.borderBoxSize;
    if (!Array.isArray(boxes) || boxes.length !== 1 || !Number.isFinite(boxes[0].inlineSize)) {
      // Do not guess padding/border dimensions from contentRect or writing-mode.
      needsDefaultMeasurement = true;
      widths.delete(entry.target);
      continue;
    }
    const width = boxes[0].inlineSize;
    // Exact comparison: even a tiny width change could cross offsetWidth rounding.
    if (widths.get(entry.target) !== width) needsDefaultMeasurement = true;
    widths.set(entry.target, width);
  }
  return needsDefaultMeasurement;
}
